/**
 * Add confs / events  / etc for traking for zuko.io 
 */
import { ZUKO_TRAK_CODE } from "../costants"

// load the trak id from env file --> trak ID can change between PROD and DEV enviromets
export const ZUKO_TRAK_ID = ZUKO_TRAK_CODE